import React, { useState, useEffect } from 'react';
import api from '../../lib/api';

// Generic read-only records table for admin views
export const RecordsTable = ({ endpoint, columns, emptyText, testId }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(endpoint)
      .then((res) => setRows(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [endpoint]);

  if (loading) return <p className="text-[#5f6d51]/60 text-sm py-8 text-center">Loading…</p>;
  if (rows.length === 0)
    return <p className="text-[#5f6d51]/60 text-sm py-8 text-center" data-testid={`${testId}-empty`}>{emptyText}</p>;

  return (
    <div className="overflow-x-auto rounded-lg border border-[#5f6d51]/10" data-testid={testId}>
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-[#f1e3eb] text-left">
            {columns.map((c) => (
              <th key={c.key} className="px-4 py-3 font-medium text-[#3c4a2a] whitespace-nowrap">
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={row.id || i} className="border-t border-[#5f6d51]/10 hover:bg-[#f1e3eb]/30">
              {columns.map((c) => (
                <td key={c.key} className="px-4 py-3 text-[#5f6d51] align-top">
                  {c.render ? c.render(row) : row[c.key] ?? '—'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const formatDate = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  } catch {
    return iso;
  }
};
